import BaseModel from './base_model';

// App.Models.Engagement
export default BaseModel.extend({
  urlRoot: '/engagements'
});
